import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { setLoginToken } from '../../utils/auth';
import { ActionButton } from './common/AdminButtons';

const LoginWrapper = styled.div`
  text-align: center;
`;


const Login: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');
        const error = queryParams.get('error');
    
        if (token) {
          setLoginToken(token);
          navigate('/halo/dashboard');
        } else if (error) {
          // Handle login error, maybe show an error message
          console.error('Login failed');
        }
      }, [location, navigate]);

    return (
    <LoginWrapper>
        <h2>Admin Login</h2>
        <ActionButton onClick={() => window.location.href = process.env.REACT_APP_API_URL + '/halo/login'}>
        Login with Google
        </ActionButton>
    </LoginWrapper>
    );
}

export default Login;